import { SchemaItem } from '@/components/form/types/schemaItem';
import { YapInputValidationError } from '@/components/form/types/yapInputValidationError';

export default () => {
  function filterErrorFor(name: string, errors: Array<YapInputValidationError>) {
    return errors.filter((e) => e.instancePath?.includes(name) || e.params.missingProperty === name)[0];
  }

  function validateSchemaPattern(schema: SchemaItem, value: string) {
    let check = true;
    if (schema.pattern) {
      const regexPattern = new RegExp(schema.pattern);
      check = regexPattern.test(value);
    }
    return check;
  }

  return {
    filterErrorFor,
    validateSchemaPattern
  };
};
